import type { ImplementedGhostId } from "../ghosts/GhostDefinitions";

export const LEVEL_INTRO_DURATION_SECONDS = 3;
export const LEVEL_INTRO_REDUCED_DURATION_SECONDS = 1.25;

export const LEVEL_INTRO_TITLES: Readonly<Record<ImplementedGhostId, string>> = {
  toyol: "LEVEL 1 : TOYOL",
  polong: "LEVEL 2 : POLONG",
  pocong: "LEVEL 3 : POCONG",
  penanggal: "LEVEL 4 : PENANGGAL",
  pontianak: "LEVEL 5 : PONTIANAK",
};

export interface LevelIntroductionDescriptor {
  readonly level: number;
  readonly ghost: ImplementedGhostId;
  readonly title: string;
  readonly finalBoss: boolean;
  readonly durationSeconds: number;
}

/** Presentation-only phase. Campaign progression remains owned by EncounterDirector. */
export class LevelIntroductionState {
  private readonly introducedLevels = new Set<number>();
  private current?: LevelIntroductionDescriptor;
  private elapsed = 0;

  get isActive(): boolean { return this.current !== undefined; }
  get activeIntroduction(): LevelIntroductionDescriptor | undefined { return this.current; }
  get elapsedSeconds(): number { return this.elapsed; }

  begin(level: number, ghost: ImplementedGhostId, reducedMotion = false): LevelIntroductionDescriptor | undefined {
    const normalized = Math.max(1, Math.min(5, Math.floor(level)));
    if (this.introducedLevels.has(normalized)) return undefined;
    this.introducedLevels.add(normalized);
    this.elapsed = 0;
    this.current = {
      level: normalized,
      ghost,
      title: LEVEL_INTRO_TITLES[ghost],
      finalBoss: ghost === "pontianak",
      durationSeconds: reducedMotion ? LEVEL_INTRO_REDUCED_DURATION_SECONDS : LEVEL_INTRO_DURATION_SECONDS,
    };
    return this.current;
  }

  update(deltaSeconds: number): boolean {
    if (!this.current) return false;
    this.elapsed += Math.max(0, deltaSeconds);
    if (this.elapsed < this.current.durationSeconds) return false;
    this.current = undefined;
    this.elapsed = 0;
    return true;
  }

  cancel(): void {
    this.current = undefined;
    this.elapsed = 0;
  }
}
